import { Injectable } from "@angular/core";
import { tap } from "rxjs/operators";
import { BaseEntityService } from "./rest-common.service";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";

@Injectable({
  providedIn: "root",
})
export class ReportingService extends BaseEntityService {
  constructor(public http: HttpClient) {
    super();
  }
  public resource_url = `${this.BASE_API_URL}/report/`;

  // saveQuery(data, params = {}) {
  //   let url = this.buildUrl(`${this.BASE_API_URL}/query/`, '', params);
  //   return this.post(url, data);
  // }

  getReportType(params = {}) {
    let url = this.buildUrl(`${this.BASE_API_URL}/report/types/`, '', params);
    return this.get(url);
  }

  // getAllQueries(params = {}) {
  //   let url = this.buildUrl(`${this.BASE_API_URL}/query/`, "", params)
  //   return this.get(url)
  // }

  // getQueryByID(id, params = {}) {
  //   let url = this.buildUrl(`${this.BASE_API_URL}/query/`, id, params)
  //   return this.get(url)
  // }

  // updateQuery(id, data, params = {}) {
  //   let url = this.buildUrl(`${this.BASE_API_URL}/query/`, id, params)
  //   return this.put(url, data)
  // }

  getReportDetails(params = {}): Observable<any> {
    let url = this.buildUrl(`${this.BASE_API_URL}/report/meta/`, '', params);
    return this.get(url);
  }

  getReportData(id: number, params = {}) {
    // let url= `${this.BASE_API_URL}/report/report_data/${id}`
    let url = this.buildUrl(`${this.BASE_API_URL}/report/${id}`, '', params);
    return this.get(url);
    // params['get_data'] = '1';
    // return this.http
    //   .get(this.buildUrl(`${this.BASE_API_URL}/report/`, id, params), {
    //     responseType: "text",
    //   })
    //   .pipe(
    //     tap(
    //       (data) => data,
    //       (error) => console.log(error)
    //     )
    //   );
  }

  downloadReortData(id,params){
    let url = this.buildUrl(`${this.resource_url}${id}/download/`, '', params);
    return this.get(url);
  }

  // getPreviousQueryData(params?: object) {
  //   let url = `${this.BASE_API_URL}/report/report_latest_query/`;
  //   return this.get(this.buildUrl(url, "", params));
  // }

  getMediaType(params = "") {
    let url = `${this.BASE_API_URL}/media-type/?fields=id,name${params}`;
    return this.get(url);
  }

  getAdvertiserCurrency(params = "") {
    let url = `${this.BASE_API_URL}/currency/?fields=id,name${params}`;
    return this.get(url);
  }

  getPlacement(params = "") {
    let url = `${this.BASE_API_URL}/placement/?fields=id,name${params}`;
    return this.get(url);
  }

  getSplit(params = "") {
    let url = `${this.BASE_API_URL}/split/?fields=id,name${params}`;
    return this.get(url);
  }
  getAllCampaigns(params = "") {
    return this.get(`${this.BASE_API_URL}/campaign/?fields=id,name${params}`);
  }

  getPublisher(params = "") {
    return this.get(`${this.BASE_API_URL}/publisher/?fields=id,name${params}`);
  }

  getSellers(params = "") {
    return this.get(`${this.BASE_API_URL}/seller/?fields=id,name${params}`);
  }

  getCreativeSizes(params = "") {
    return this.get(`${this.BASE_API_URL}/sizes/?fields=id,name${params}`);
  }
}

@Injectable({
  providedIn: "root",
})
export class QueryService extends BaseEntityService {
  constructor(public http: HttpClient) {
    super();
  }
  public resource_url = `${this.BASE_API_URL}/query/`;

  saveViewedQuery(id, params = {}, name?) {
    let url = this.buildUrl(`${this.resource_url}${id}/save/`, '', params)
    let data = {}
    if (name) {
      data = { name: name }
    }
    return this.put(url, data)
  }

}
